function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M22.406 22.831H9.595V11.819h12.811v11.012zm-12.554-.258h12.295V12.078H9.852v10.495z" /><path d="M9.754 12.073l-.062-.25 10.752-2.654v2.779h-.258v-2.45L9.754 12.073z" /></svg>;
});